import { render, staticRenderFns } from "./ReasonBlock.vue?vue&type=template&id=7a7ca8f6&"
import script from "./ReasonBlock.vue?vue&type=script&lang=js&"
export * from "./ReasonBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports